<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			body: ISbStoryData[];
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div
	use:editable={content}
	class="mx-5 mt-6 text-brown-1 lg:mx-15 lg:mb-9 lg:mt-7 xl:max-w-[420px]"
>
	{#each content.body || [] as block}
		<Blok content={block} />
	{/each}
</div>
